import { Link } from 'react-router-dom';
import { RefreshCw, ChevronLeft } from 'lucide-react';

export const RefundPolicy = () => {
  return (
    <div className="subpage-container" data-testid="refund-policy-page">
      <section className="subpage-hero policy-hero">
        <div className="subpage-hero-inner">
          <div className="policy-top-nav">
            <Link to="/" className="policy-back-link">
              <ChevronLeft size={16} /> Back to Home
            </Link>
          </div>

          <div className="policy-header-content">
            <div className="policy-hero-badge">
              <RefreshCw size={15} /> CANCELLATIONS &amp; ADJUSTMENTS
            </div>
            <h1 className="subpage-title">Refund and Cancellation Policy</h1>
            <p className="policy-effective-date">
              Effective Date: September 9, 2026 · Giraffe Entertainment &amp; Experiences (Giraffe Group)
            </p>
          </div>
        </div>
      </section>

      <div className="subpage-body site-container policy-body">
        <div className="policy-content-card">
          <section className="policy-section">
            <h2>01. General Cancellation Principles</h2>
            <p>
              At <strong>Giraffe Entertainment &amp; Experiences ("GEE")</strong>, we understand that journey schedules, pilgrimage itineraries, and travel circumstances can encounter unforeseen changes. We strive to provide clear, fair, and transparent cancellation and rescheduling terms for all our ticketed attractions and 7D cinema screenings.
            </p>
          </section>

          <section className="policy-section">
            <h2>02. Individual Ticket Cancellations</h2>
            <p>
              For standard individual and family tickets purchased online or through authorized booking counters:
            </p>

            <div className="policy-timeline-grid">
              <div className="policy-timeline-card">
                <span className="timeline-badge timeline-full">48+ Hours Notice</span>
                <h4>100% Full Refund</h4>
                <p>Cancellations submitted at least 48 hours prior to your scheduled screening receive a complete 100% refund of the ticket price with zero deduction.</p>
              </div>

              <div className="policy-timeline-card">
                <span className="timeline-badge timeline-partial">24 – 48 Hours Notice</span>
                <h4>50% Refund or Free Reschedule</h4>
                <p>Receive a 50% refund, or opt for a 100% complimentary date and showtime reschedule voucher valid for 90 days.</p>
              </div>

              <div className="policy-timeline-card">
                <span className="timeline-badge timeline-none">Under 24 Hours / No-Show</span>
                <h4>Non-Refundable</h4>
                <p>Because seats are reserved and capacities are strictly capped, cancellations within 24 hours of showtime or failure to arrive are non-refundable.</p>
              </div>
            </div>
          </section>

          <section className="policy-section">
            <h2>03. Group &amp; Institutional Bookings</h2>
            <p>
              For corporate events, school tours, and bulk group reservations (15+ seats):
            </p>
            <ul className="policy-list">
              <li><strong>7+ Days Prior to Showtime:</strong> 100% refund (minus a 5% administrative payment processing fee).</li>
              <li><strong>3 to 6 Days Prior to Showtime:</strong> 50% refund of total booking fee.</li>
              <li><strong>Less than 72 Hours Prior:</strong> Non-refundable; rescheduling can be arranged subject to theater slot availability.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>04. Weather &amp; Operational Contingencies</h2>
            <p>
              In the rare event that an attraction or screening cannot take place due to:
            </p>
            <ul className="policy-list">
              <li>Severe inclement weather, riverfront flooding, or local authority directives.</li>
              <li>Unscheduled technical maintenance or power grid interruptions.</li>
            </ul>
            <p>
              Guests will be offered an <strong>immediate 100% full refund</strong>, or the option of an open VIP voucher valid for any subsequent screening at their convenience.
            </p>
          </section>

          <section className="policy-section">
            <h2>05. Refund Processing Timelines &amp; Methods</h2>
            <p>
              Approved refunds are credited directly back to the original method of payment (UPI, Credit/Debit Card, or Net Banking) utilized during booking. The standard processing timeframe is <strong>5 to 7 business banking days</strong> from the date of approval.
            </p>
          </section>

          <section className="policy-section">
            <h2>06. How to Request a Cancellation</h2>
            <p>
              To request a cancellation or reschedule, please submit your request along with your booking ID and registered mobile number:
            </p>
            <div className="policy-contact-box">
              <p><strong>Guest Services Desk</strong></p>
              <p>Email: <a href="mailto:hello@giraffegroup.in">hello@giraffegroup.in</a></p>
              <p>Subject Line: <em>"Cancellation Request - [Your Booking ID]"</em></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
